import makeBenefitTopic from '@main/factories/pages/makeBenefitTopic';
import { useData } from 'vike-react/useData';

import type { Data } from './+data';

export function Page() {
	const { topic } = useData<Data>();

	return makeBenefitTopic(topic);
}
